module.exports = __webpack_public_path__ + "assets/declared.4947c265.svg";